var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"menu"}},[_c('v-treeview',{attrs:{"activatable":"","dense":"","hoverable":"","items":_vm.items},scopedSlots:_vm._u([{key:"label",fn:function(props){return [(props.item.to)?_c('router-link',{attrs:{"to":{ name: props.item.to }}},[_vm._v(_vm._s(props.item.name))]):_c('span',[_vm._v(_vm._s(props.item.name))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }